export const AMAZON = {
  ACCESS_TOKEN_015: 'AMAZON_SESSION_ID_015',
  ACCESS_TOKEN_029: 'AMAZON_SESSION_ID_029',
  CART_LINE004: 'CART_LINE004',
  CART_LINE029: 'CART_LINE029',
  CART_LINE015: 'CART_LINE015',
  CART_LINE028: 'CART_LINE028',
  SUBSCRIPTION_AMOUNT: 100000,
  NORMAL_AMOUNT: 10000000,
  BACKUP_AMAPAY_015: 'BACKUP_AMAPAY_015',
  BACKUP_AMAPAY_029: 'BACKUP_AMAPAY_029',
  SHIPPING_FEE: 'SHIPPING_FEE',
}

export const BRAND_CARD = {
  VISA: 'Visa',
  AMEX: 'American Express',
  DINNERSCLUB: 'Dinnerclub',
  MASTER: 'Mastercard',
  JCB: 'JCB',
}
